// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js';
import 'vuetify/dist/vuetify.min.css';
import '@/lib/filters';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import SvgSprite from 'vue-svg-sprite';
import Vuetify from 'vuetify';
import Vue2Filters from 'vue2-filters';
import VueWait from 'vue-wait';
import HttpStatus from 'http-status-codes';
import MainLayout from '@/layouts/MainLayout';
import config from '@/config';
import apiHelpers from '@/lib/api';
import { AUTH_LOGOUT, AUTH_TOKEN } from '@/apps/auth/store/types';
import { API_ERROR_SET } from '@/apps/core/store/types';
import store from '@/store';
import axios from '@/api/axios';
import api from '@/api';
import { SOME_API_ERROR_MSG } from '@/config/constants';


import IdleVue from 'idle-vue';
import { getAppRouter } from '@/lib/utils';
import '@/style/global.scss';

Vue.use(Vue2Filters);
Vue.use(Vuetify);
Vue.use(Vuelidate);
Vue.use(VueWait);

Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime:     10 * 60 * 1000, // 10 minutes.
});

Vue.use(SvgSprite, {
  url:   'static/sprite.svg',
  class: 'svg-sprite',
});

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    key:       config.googleMapApiKey,
    // Enable more Google Maps libraries here
    libraries: 'places',
  },
});

const app = new Vue({
  router:     getAppRouter(),
  store,
  components: {
    layout: MainLayout,
  },
  template: '<div><layout/></div>',
  wait:     new VueWait({ useVuex: true }),
});

axios.interceptors.response.use(
  response => Object.assign({}, response, {
    data: (
      apiHelpers.camelCaseResponseAdapter(response.data ? response.data : {})
    ),
  }),
  (error) => {
    // show popup message
    if (!error.response) {
      store.dispatch(API_ERROR_SET, {
        detail: 'The server is not available, please retry the request later.',
      });

      return Promise.reject(error);
    }

    // handle expired token
    // it's need to save the current order
    if (error.response.status === HttpStatus.UNAUTHORIZED && error.response.data.detail === 'Token was expired.') {
      // Try request again with new token
      return api.auth.refreshToken({})
        .then((data) => {
          // New request with new token
          const errorConfig = error.config;

          store.dispatch(AUTH_TOKEN, data.data);
          errorConfig.headers.Authorization = `Bearer ${data.token}`;

          return new Promise((resolve, reject) => {
            axios.request(errorConfig).then((response) => {
              resolve(response);
            }).catch((error) => {
              reject(error);
            });
          });
        })
        .catch((error) => {
          Promise.reject(error);
        });
    }

    if (error.response.status === HttpStatus.UNAUTHORIZED && error.response.data.detail !== 'Token was expired.') {
      store.dispatch(AUTH_LOGOUT);
      app.$router.push({ name: 'menu' });
      Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

Vue.config.errorHandler = (error) => {
  if ('response' in error) {
    const { data } = error.response;
    const { detail } = data;

    store.dispatch(API_ERROR_SET, {
      data,
      detail: detail || SOME_API_ERROR_MSG,
    });
  } else {
    throw error;
  }
};

app.$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js